import { css, mediaQueries } from '@eti/styles';
import { Dialog } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { useState } from 'react';
import { screenReaderOnly } from '../../common/utils/styles';
import SeatMapContent from '../containers/SeatMapContentContainer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const seatMapDialogStyles = isSummaryShowing => css`
  border-radius: 0.1875rem;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  height: inherit;
  max-height: 100%;
  outline: none;
  position: absolute;

  > div {
    height: 100%;
  }

  & > div > div:nth-of-type(1) {
    display: none;
  }

  & > div > div:nth-of-type(2) {
    ${!isSummaryShowing ? 'overflow: hidden;' : ''}
    padding-inline: 0;
  }

  @media ${mediaQueries.medium.up} {
    height: 90vh;
    inset: 20px;
    margin: auto;
    max-width: 48rem;
  }

  @media ${mediaQueries.large.up} {
    max-width: 1200px;
  }

  @media (min-width: 1200px) {
    width: 1200px;
  }
`;
const SeatMapOverlay = _ref => {
  let {
    show,
    form,
    order,
    setIsSeatMapModalOpen,
    travelers,
    bounds,
    isPostBooking,
    callback
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isSummaryShowing, setIsSummaryShowing] = useState(false);
  return /*#__PURE__*/_jsxs(Dialog, {
    className: seatMapDialogStyles(isSummaryShowing),
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": "seatMap-dialog",
    isOpen: show,
    title: "" // To be replaced with a text key
    ,
    children: [/*#__PURE__*/_jsx(SeatMapContent, {
      bounds: bounds,
      callback: callback,
      form: form,
      isPostBooking: isPostBooking,
      isSummaryShowing: isSummaryShowing,
      order: order,
      setIsSeatMapModalOpen: setIsSeatMapModalOpen,
      setIsSummaryShowing: setIsSummaryShowing,
      travelers: travelers
    }), /*#__PURE__*/_jsx("div", {
      "aria-live": "polite",
      className: screenReaderOnly,
      id: "live-region-all-passengers-seated",
      role: "region"
    })]
  });
};
export default SeatMapOverlay;
//# sourceMappingURL=SeatMapOverlay.js.map